const findSmallestShade = (palette) => Math.min.apply(null, Object.keys(palette).map(Number));

export default findSmallestShade;
